import { useEffect, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { getYouTubeDetails } from "../courseDetail/YouTubePreview";

const YoutubeVideoModel = ({ show, close, videoUrl, title }) => {
  const isMobile = window.innerWidth < 768;

  const [isLoading, setIsLoading] = useState(true);
  const details = getYouTubeDetails(videoUrl);
  const playerUrl = details ? new URL(details.embedUrl) : null;
  if (playerUrl && !isMobile) {
    playerUrl.searchParams.set("autoplay", "1");
    playerUrl.searchParams.set("mute", "1");
  }
  const embedUrl = playerUrl?.href;

  useEffect(() => {
    if (show) setIsLoading(true);
  }, [show, videoUrl]);

  return (
    <Modal show={show} centered onHide={close} size="lg">
      <Modal.Header closeButton>
        <Modal.Title style={{ color: "black" }}>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body className="text-center py-3">
        <div className="video-container ratio ratio-16x9 position-relative">
          {embedUrl && isLoading && (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{
                position: "absolute",
                inset: 0,
                background: "#00000010",
                zIndex: 1,
              }}
            >
              <Spinner />
            </div>
          )}

          {show && embedUrl && (
            <iframe
              src={embedUrl}
              title={title || "YouTube video"}
              allow="autoplay; encrypted-media"
              allowFullScreen
              style={{ borderRadius: "12px" }}
              onLoad={() => setIsLoading(false)}
            />
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export const YoutubeVideoLink = ({ href, title, children, ...linkProps }) => {
  const [show, setShow] = useState(false);

  return (
    <>
      <a
        {...linkProps}
        href={href}
        onClick={(event) => {
          if (!getYouTubeDetails(href)) return;
          event.preventDefault();
          setShow(true);
        }}
      >
        {children}
      </a>
      <YoutubeVideoModel
        show={show}
        close={() => setShow(false)}
        videoUrl={href}
        title={title}
      />
    </>
  );
};

export default YoutubeVideoModel;
